var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('balance-detail',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],attrs:{"value":_vm.wallet,"sourceId":_vm.userId,"targets":_vm.students}}),(_vm.loading)?_c('loading-page'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }